<template>
  <div class="add-box">
    <el-form ref="menuform" :model="menuform" label-width="120px" class="user-form">
      <el-form-item label="类型:">
        <el-radio-group v-model="menuform.type">
          <el-radio :label="0">目录</el-radio>
          <el-radio :label="1">菜单</el-radio>
          <el-radio :label="2">按钮</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="菜单名称:">
        <el-input v-model="menuform.name" placeholder="菜单名称" class="user-input" />
      </el-form-item>

      <el-form-item label="上级菜单:">
        <el-cascader
          ref="lastMenu"
          :show-all-levels="false"
          :options="menuList"
          :props="optionProps"
          class="user-input"
          placeholder="一级菜单"
          clearable
          @change="handleItemChange"
        />
      </el-form-item>

      <el-form-item v-if="menuform.type==1" label="菜单URL:">
        <el-input v-model="menuform.url" placeholder="菜单URL" class="user-input" />
      </el-form-item>

      <el-form-item v-if="menuform.type==1 || menuform.type==2" label="授权标识:">
        <el-input
          v-model="menuform.perms"
          type="textarea"
          :rows="4"
          placeholder="多个逗号获取换行分隔,如:user:list,user:create"
        />
      </el-form-item>

      <el-form-item v-if="menuform.type==0 || menuform.type==1" label="排序号:">
        <el-input-number v-model="menuform.orderNum" :min="0" :max="1000" class="user-input" />
      </el-form-item>

      <el-form-item v-if="menuform.type==0 || menuform.type==1" label="图标样式:">
        <el-input v-model="menuform.icon" placeholder="图标样式" class="user-input" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="save">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
	    data() {
    return {
      menuList: [
      ],

      optionProps: {
        checkStrictly: true,
        emitPath: false,
        expandTrigger: 'hover',
        value: 'menuId',
        label: 'name',
        children: 'children'
      },

      menuform: {
        type: 1,
        name: '',
        orderNum: 0,
        parentId: 0,
        parentName: '一级菜单',
        perms: '',
        url: '',
        icon: ''
      }
    }
	    },

  created() {
    this.$emit('setCurrentMenu', '菜单管理')
    this.getlastdept()
  },

	    methods: {
    getlastdept() {
      const vm = this
      vm.axios.get(vm.homePath() + '/sys/menu/select')
        .then(res => {
          if (res.data.status == '000000') {
            const data = res.data.menuList
            const data1 = data.filter(item => item.parentId == 0)
            const data2 = data.filter(item => item.parentId != 0)
            const data3 = data1.concat(data2)
            vm.menuList = vm.filterNull(vm.toTreeData(data3, 'parentId', 'menuId'))
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch(error => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
				    if (data[i].children.length < 1) {
				        data[i].children = undefined
				    } else {
				        vm.filterNull(data[i].children)
				    }
      }
      return data
    },

    handleItemChange(val) {
      this.menuform.parentId = val
      this.menuform.parentName = this.$refs['lastMenu'].getCheckedNodes()[0].label
    },

    save() {
      let past = true
      if (this.menuform.name == '') {
        this.$alert('菜单名称不能为空', '提示')
        past = false
      }

      if (this.menuform.type == 0 || this.menuform.type == 1) {
        if (this.menuform.icon == '') {
          this.$alert('请输入图标样式', '提示')
          past = false
        }
      }

      if (past) {
        const vm = this
        vm.axios.post(vm.homePath() + '/sys/menu/save', {
          name: vm.menuform.name,
          parentId: vm.menuform.parentId,
          parentName: vm.menuform.parentName,
          orderNum: vm.menuform.orderNum,
          type: vm.menuform.type,
          perms: vm.menuform.perms,
          url: vm.menuform.url,
          icon: vm.menuform.icon
        })
          .then(response => {
            if (response.data.status == '000000') {
              vm.$alert('增加成功', '提示', {
                callback: action => {
                  vm.$router.push('/index/menu')
                  vm.$emit('menuchange')
                }
              })
            } else {
              console.log(response.data.message)
            }
          })
          .catch(error => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/menu')
    }
	    }
	  }
</script>

<style>
</style>

